import React, { ComponentType } from 'react';
import HighchartsReact from 'highcharts-react-official';
import { useChartViewOptions } from '../chart-data/chart-view-options';
import { useFluentChartViewOptions } from '../chart-data/fluent-chart-view-options';
import { IPerformanceCardProps } from '../types/types';


export function withHighchartsChart<P extends IPerformanceCardProps>(WrappedComponent: ComponentType<P>): ComponentType<Omit<P, 'Chart' | 'useChartProps'>> {
  const HoC = props => (<WrappedComponent
    {...props as any}
    Chart={HighchartsReact}
    useChartProps={useChartViewOptions}
  />);

  return HoC;
}

// *********** DELETE THIS WHEN FLUENT CHART IS ADDED ***********************
const MockFluentChart = () => (<div>Mock Fluent Chart</div>);
// *********** DELETE THIS WHEN FLUENT CHART IS ADDED ***********************
export function withFluentChart<P extends IPerformanceCardProps>(WrappedComponent: ComponentType<P>): ComponentType<Omit<P, 'Chart' | 'useChartProps'>> {
  const HoC = props => (<WrappedComponent
    {...props as any}
    Chart={MockFluentChart}
    useChartProps={useFluentChartViewOptions}
  />);

  return HoC;
}
